import { render, staticRenderFns } from "./commonInput.vue?vue&type=template&id=538f0faa&scoped=true&"
import script from "./commonInput.vue?vue&type=script&lang=ts&"
export * from "./commonInput.vue?vue&type=script&lang=ts&"
import style0 from "./commonInput.vue?vue&type=style&index=0&id=538f0faa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f0faa",
  null
  
)

export default component.exports